"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6717],{

/***/ 81628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useCompanyDictionary; }
/* harmony export */ });
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86896);

/** Translations for all company field names */ var useCompanyDictionary = function() {
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var dictionary = {
        companyID: '',
        name: intl.formatMessage({
            id: 'company.name',
            defaultMessage: 'Toiminimi'
        }),
        marketingName: intl.formatMessage({
            id: 'company.marketingName',
            defaultMessage: 'Markkinointinimi'
        }),
        businessID: '',
        description: intl.formatMessage({
            id: 'company.description',
            defaultMessage: 'Yritysesittely'
        }),
        dateEstablished: intl.formatMessage({
            id: 'company.dateEstablished',
            defaultMessage: 'Perustamisvuosi'
        }),
        timeCreate: '',
        phone: intl.formatMessage({
            id: 'company.phone',
            defaultMessage: 'Puhelinnumero'
        }),
        fax: intl.formatMessage({
            id: 'company.fax',
            defaultMessage: 'Faksi'
        }),
        email: intl.formatMessage({
            id: 'company.email',
            defaultMessage: 'S\xe4hk\xf6postiosoite'
        }),
        homepage: intl.formatMessage({
            id: 'company.homepage',
            defaultMessage: 'Kotisivu'
        }),
        numberOfEmployees: intl.formatMessage({
            id: 'company.numberOfEmployees',
            defaultMessage: 'Henkil\xf6st\xf6m\xe4\xe4r\xe4'
        }),
        turnover: intl.formatMessage({
            id: 'company.turnover',
            defaultMessage: 'Liikevaihto'
        }),
        postalAddress: intl.formatMessage({
            id: 'company.postalAddress',
            defaultMessage: 'Postiosoite'
        }),
        visitingAddress: intl.formatMessage({
            id: 'company.visitingAddress',
            defaultMessage: 'Vierailuosoite'
        }),
        tol: intl.formatMessage({
            id: 'company.tol',
            defaultMessage: 'P\xe4\xe4toimiala (TOL2008)'
        }),
        businessType: '',
        domicile: intl.formatMessage({
            id: 'company.domicile',
            defaultMessage: 'Kotipaikka'
        }),
        projectTypes: intl.formatMessage({
            id: 'company.projectTypes',
            defaultMessage: 'Hanketyypit'
        }),
        contractingForms: intl.formatMessage({
            id: 'company.contractingForms',
            defaultMessage: 'Urakointimuodot'
        }),
        customerTargetGroups: intl.formatMessage({
            id: 'company.customerTargetGroups',
            defaultMessage: 'Asiakaskohderyhm\xe4t'
        }),
        machineryTypes: intl.formatMessage({
            id: 'company.machineryTypes',
            defaultMessage: 'Konekanta'
        }),
        taitoCompetences: intl.formatMessage({
            id: 'company.taitoCompetences',
            defaultMessage: 'Taitorekisteri'
        }),
        languages: intl.formatMessage({
            id: 'company.languages',
            defaultMessage: 'Ty\xf6maakielet'
        }),
        talo80: intl.formatMessage({
            id: 'company.talo80',
            defaultMessage: 'Toimialaluokat'
        }),
        operationalAreas: intl.formatMessage({
            id: 'company.operationalAreas',
            defaultMessage: 'Toimialueet'
        }),
        locations: intl.formatMessage({
            id: 'company.locations',
            defaultMessage: 'Toimipisteet'
        }),
        contactPersons: intl.formatMessage({
            id: 'company.contactPersons',
            defaultMessage: 'Yhteyshenkil\xf6t'
        }),
        // @ts-ignore
        sales: intl.formatMessage({
            id: 'company.sales',
            defaultMessage: 'Myynti'
        }),
        references: intl.formatMessage({
            id: 'company.references',
            defaultMessage: 'Referenssit'
        }),
        referencesDescription: intl.formatMessage({
            id: 'company.references.description',
            defaultMessage: 'Kuvaus'
        }),
        referencesValue: intl.formatMessage({
            id: 'company.references.value',
            defaultMessage: 'Urakan arvo'
        }),
        referencesDate: intl.formatMessage({
            id: 'company.references.date',
            defaultMessage: 'Ajankohta'
        }),
        referencesCustomer: intl.formatMessage({
            id: 'company.references.customer',
            defaultMessage: 'Tilaaja'
        })
    };
    return dictionary;
};


/***/ }),

/***/ 2971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ar": function() { return /* binding */ StyledLabel; },
/* harmony export */   "gN": function() { return /* binding */ Field; },
/* harmony export */   "Od": function() { return /* binding */ Skeleton; },
/* harmony export */   "pu": function() { return /* binding */ Quote; },
/* harmony export */   "Af": function() { return /* binding */ Chip; }
/* harmony export */ });
/* unused harmony export SkeletonChip */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44012);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var _material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58365);
/* harmony import */ var _PremiumIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16742);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74815);







function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: ",
        ";\n  opacity: 0.8;\n\n  > .premium-icon {\n    margin-left: 0.2rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  .value {\n    display: ",
        ";\n    align-items: center;\n    line-height: ",
        "rem;\n    margin-top: 0.3rem;\n    font-size: ",
        "rem;\n    font-weight: ",
        ";\n\n    svg:first-child {\n      margin-right: 0.4rem;\n      margin-bottom: -1px;\n    }\n\n    span {\n      margin-right: 0.4rem;\n    }\n  }\n\n  .empty {\n    line-height: ",
        "rem;\n    font-size: 1rem;\n    font-weight: normal;\n    opacity: 0.4;\n  }\n\n  a {\n    display: inline-flex;\n    align-items: center;\n\n    /* NOTE! This should probably be in the main stylesheet, or is it an exception? */\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  &:before,\n  &:after {\n    display: inline-block;\n    opacity: 0.4;\n  }\n  &:before {\n    margin-right: 0.1rem;\n    content: '“';\n  }\n  &:after {\n    margin-left: 0.1rem;\n    content: '”';\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  display: inline-block;\n  position: relative;\n  margin-top: 0.4rem;\n  margin-right: 0.4rem;\n  padding: 0.3rem 0.6rem;\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: 3px;\n\n  .skeleton {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    height: auto;\n    border-radius: 3px;\n    background: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var StyledLabel = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db049034-0"
})(_templateObject(), _Theme__WEBPACK_IMPORTED_MODULE_3__/* .Color.black */ .Il.black);
var StyledField = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db049034-1"
})(_templateObject1(), function(param) {
    var chip = param.chip;
    return chip ? 'block' : 'flex';
}, function(param) {
    var large = param.large;
    return large ? 1.9 : 1.4;
}, function(param) {
    var large = param.large;
    return large ? 1.5 : 1;
}, function(param) {
    var large = param.large;
    return large ? 500 : 400;
}, function(param) {
    var large = param.large;
    return large ? 1.9 : 1.4;
}, _Theme__WEBPACK_IMPORTED_MODULE_3__/* .Color.primary */ .Il.primary);
/** Company field with label and value */ var Field = function(param) {
    var label = param.label, premiumOnly = param.premiumOnly, large = param.large, loading = param.loading, empty = param.empty, _chip = param.chip, chip = _chip === void 0 ? false : _chip, _premium = param.premium, premium = _premium === void 0 ? false : _premium, children = param.children;
    var isLoading = loading;
    var isPremium = premium;
    var content = children;
    if (isLoading && premiumOnly) {
        // If is loading an is premium only, render a loading indicator
        content = chip ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonChip, {
                    loading: true,
                    width: "20%"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonChip, {
                    loading: true,
                    width: "28%"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonChip, {
                    loading: true,
                    width: "18%"
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Skeleton, {
            width: "30%",
            loading: true
        });
    } else if (premiumOnly && empty && !isPremium) {
        // If field is premium only, but the user is not premium, render gray box
        content = chip ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonChip, {
                    width: "20%"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonChip, {
                    width: "28%"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonChip, {
                    width: "18%"
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Skeleton, {
            width: "30%"
        });
    } else if (empty) {
        // If field is marked as "empty", render the "not available" state
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
            className: "empty",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                id: "company.emptyField",
                defaultMessage: "Ei saatavilla"
            })
        });
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledField, {
        large: large,
        chip: chip,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledLabel, {
                className: "label",
                children: [
                    label,
                    " ",
                    premiumOnly && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PremiumIcon__WEBPACK_IMPORTED_MODULE_2__/* .PremiumIcon */ .T, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "value",
                children: content
            })
        ]
    }));
};
/** Show skeleton value
 *  Use to show skeleton value
 * */ var Skeleton = function(param) {
    var _width = param.width, width = _width === void 0 ? 'auto' : _width, _height = param.height, height = _height === void 0 ? 'auto' : _height, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        animation: loading ? 'wave' : false,
        width: width,
        height: height
    });
};
/** Wrap field value in quotes */ var Quote = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db049034-2"
})(_templateObject2());
/** Render info chip */ var Chip = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db049034-3"
})(_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var selected = param.selected;
    return selected ? _Theme__WEBPACK_IMPORTED_MODULE_3__/* .Color.primary */ .Il.primary : 'rgb(224, 224, 224)';
}, function(param) {
    var selected = param.selected;
    return selected ? _Theme__WEBPACK_IMPORTED_MODULE_3__/* .Color.white */ .Il.white : _Theme__WEBPACK_IMPORTED_MODULE_3__/* .Color.black */ .Il.black;
});
/** Render skeleton info chip
 *  Implemented as MUI Skeleton rendered inside a normal chip to get exact same dimensions
 * */ var SkeletonChip = function(param) {
    var _width = param.width, width = _width === void 0 ? 'auto' : _width, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Chip, {
        width: width,
        children: [
            "\xa0",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "skeleton",
                animation: loading ? 'wave' : false,
                variant: "rect"
            })
        ]
    });
};


/***/ }),

/***/ 66235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rj": function() { return /* binding */ Grid; },
/* harmony export */   "sg": function() { return /* binding */ Column; },
/* harmony export */   "ck": function() { return /* binding */ Item; },
/* harmony export */   "LZ": function() { return /* binding */ Spacer; },
/* harmony export */   "KH": function() { return /* binding */ BasicInfoGrid; }
/* harmony export */ });
/* unused harmony exports ItemStyle, SpacerStyle */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74815);



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: column;\n    padding: 1rem;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  padding: 2rem;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    &:not(:last-of-type) {\n      padding-right: 0;\n      border-right: none;\n    }\n\n    &:not(:first-of-type) {\n      padding-left: 0;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n\n  &:not(:last-of-type) {\n    padding-right: 1rem;\n    border-right: 2px solid ",
        ";\n  }\n\n  &:not(:first-of-type) {\n    padding-left: 1rem;\n  }\n\n  ",
        "\n\n  ",
        " {\n    padding: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 1.2rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0.6rem 0;\n  height: 2px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n\n  > .MuiButton-root {\n    position: absolute;\n    top: 1.1rem;\n    right: 1rem;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
var Grid = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a143aefe-0"
})(_templateObject1(), _Theme__WEBPACK_IMPORTED_MODULE_1__/* .mediaQuery.small */ .cy.small((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject())));
var Column = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a143aefe-1"
})(_templateObject3(), _Theme__WEBPACK_IMPORTED_MODULE_1__/* .Color.background */ .Il.background, _Theme__WEBPACK_IMPORTED_MODULE_1__/* .mediaQuery.small */ .cy.small((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2())), Grid);
var ItemStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a143aefe-2"
})(_templateObject4());
var Item = function(param) {
    var _show = param.show, show = _show === void 0 ? true : _show, children = param.children;
    return !!show ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ItemStyle, {
        children: children
    }) : null;
};
var SpacerStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a143aefe-3"
})(_templateObject5(), _Theme__WEBPACK_IMPORTED_MODULE_1__/* .Color.background */ .Il.background);
var Spacer = function(param) {
    var _show = param.show, show = _show === void 0 ? true : _show, style = param.style;
    return !!show ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SpacerStyle, {
        style: style
    }) : null;
};
/** Has to be here, or the SSR won't work right... */ var BasicInfoGrid = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(Grid).withConfig({
    componentId: "sc-a143aefe-4"
})(_templateObject6());


/***/ }),

/***/ 6717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Omnibar": function() { return /* binding */ Omnibar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Collapse/Collapse.js
var Collapse = __webpack_require__(66037);
// EXTERNAL MODULE: ./node_modules/mdi-react/MagnifyIcon.js
var MagnifyIcon = __webpack_require__(18799);
var MagnifyIcon_default = /*#__PURE__*/__webpack_require__.n(MagnifyIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/TuneIcon.js
var TuneIcon = __webpack_require__(92514);
var TuneIcon_default = /*#__PURE__*/__webpack_require__.n(TuneIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/MenuDownIcon.js
var MenuDownIcon = __webpack_require__(88251);
var MenuDownIcon_default = /*#__PURE__*/__webpack_require__.n(MenuDownIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/MenuUpIcon.js
var MenuUpIcon = __webpack_require__(93502);
var MenuUpIcon_default = /*#__PURE__*/__webpack_require__.n(MenuUpIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/MenuRightIcon.js
var MenuRightIcon = __webpack_require__(31663);
var MenuRightIcon_default = /*#__PURE__*/__webpack_require__.n(MenuRightIcon);
// EXTERNAL MODULE: ./components/Theme.ts
var Theme = __webpack_require__(74815);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Popover/Popover.js
var Popover = __webpack_require__(52387);
// EXTERNAL MODULE: ./components/select/ListSelect.tsx
var ListSelect = __webpack_require__(62653);
// EXTERNAL MODULE: ./components/omnibar/OmnibarButton.tsx
var OmnibarButton = __webpack_require__(77249);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./components/company/CompanyFieldAndHelpers.tsx
var CompanyFieldAndHelpers = __webpack_require__(2971);
// EXTERNAL MODULE: ./node_modules/mdi-react/FilterPlusIcon.js
var FilterPlusIcon = __webpack_require__(87719);
var FilterPlusIcon_default = /*#__PURE__*/__webpack_require__.n(FilterPlusIcon);
// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(40570);
// EXTERNAL MODULE: ./context/advancedSearchStore.ts
var advancedSearchStore = __webpack_require__(94322);
// EXTERNAL MODULE: ./lib/state.ts
var lib_state = __webpack_require__(54442);
// EXTERNAL MODULE: ./context/staticStore.ts
var staticStore = __webpack_require__(30803);
// EXTERNAL MODULE: ./context/useUser.tsx
var useUser = __webpack_require__(95460);
// EXTERNAL MODULE: ./context/paywallStore.tsx
var paywallStore = __webpack_require__(90588);
;// CONCATENATED MODULE: ./components/omnibar/OmnibarSelect.tsx
















function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    .MuiPopover-paper {\n      display: flex;\n      flex-direction: column;\n      width: 400px;\n      box-shadow: 0 6px 32px rgba(149, 157, 165, 0.6);\n      border-radius: 0 0 ",
        "px ",
        "px;\n\n      .MuiInputBase-root {\n        border-radius: 0;\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  margin-bottom: 0.5rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var Styled = {
    Popover: (0,styled_components_browser_esm/* default */.ZP)(Popover/* default */.ZP).withConfig({
        componentId: "sc-bcfc70fc-0"
    })(_templateObject(), Theme/* borderRadius */.E0, Theme/* borderRadius */.E0)
};
var ChipList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bcfc70fc-1"
})(_templateObject1());
var ChipActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bcfc70fc-2"
})(_templateObject2());
var OmnibarSelect = function(param) {
    var id = param.id, title = param.title, path = param.path, chip = param.chip, onClose = param.onClose;
    var hasPremium = (0,useUser/* useUser */.a)().hasPremium;
    var ref = (0,react.useState)(null), anchorEl = ref[0], setAnchorEl = ref[1];
    var ref1 = (0,react.useState)(''), previousSelected = ref1[0], setPreviousSelected = ref1[1];
    var items = (0,lib_state/* useScopedState */.S)(staticStore/* staticState */.G, [
        path
    ])[path];
    var ref2 = (0,advancedSearchStore/* useSearchFilter */.dl)(path), state = ref2.state, set = ref2.set;
    var selected = state.selected, count = state.count;
    var open = Boolean(anchorEl);
    (0,react.useEffect)(function() {
        setPreviousSelected(selected.join(','));
    }, [
        open
    ]);
    var handleClick = function(event) {
        event.stopPropagation();
        event.preventDefault();
        // If user has no premium access, open paywall
        if (!hasPremium && (0,paywallStore/* openPaywall */.Oo)('filter')) return;
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        var selectedString = selected.join(',');
        var isChanged = previousSelected !== selectedString;
        setPreviousSelected(selectedString);
        if (onClose) onClose(isChanged);
        setAnchorEl(null);
    };
    var selectedItems = !!chip ? items.filter(function(item) {
        return selected.includes("".concat(item.id));
    }) : [];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !chip && /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarButton/* OmnibarButton */.j, {
                count: count,
                onClick: handleClick,
                children: title
            }),
            !!chip && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipList, {
                        children: selectedItems.map(function(item) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Chip */.Af, {
                                children: item.name
                            }, item.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipActions, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((FilterPlusIcon_default()), {}),
                            onClick: handleClick,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "search.advanced.chipAddButton",
                                defaultMessage: "Lis\xe4\xe4 suodatin"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled.Popover, {
                id: id,
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                style: {
                    height: '50vh',
                    minHeight: 400
                },
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSelect/* ListSelect */.H, {
                    id: "omnibar-".concat(id, "-select"),
                    selected: selected,
                    onSelect: set,
                    transparent: true,
                    showCount: false,
                    items: items
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 4 modules
var polished_esm = __webpack_require__(83852);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./context/searchStore.tsx
var searchStore = __webpack_require__(90672);
;// CONCATENATED MODULE: ./components/omnibar/OmnibarSearchButton.tsx







function OmnibarSearchButton_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function OmnibarSearchButton_templateObject() {
    var data = OmnibarSearchButton_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 66px;\n  height: 66px;\n"
    ]);
    OmnibarSearchButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OmnibarSearchButton_templateObject1() {
    var data = OmnibarSearchButton_taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    width: calc(100% - 0.6rem);\n    height: calc(100% - 0.6rem);\n    font-size: 1.06rem;\n    font-weight: 500;\n    font-family: 'Roboto', sans-serif;\n    background: none;\n    background-color: ",
        ";\n    border-radius: 4px;\n    border: none;\n    outline: none;\n    color: ",
        ";\n\n    cursor: pointer;\n\n    > .MuiCircularProgress-root {\n      position: absolute;\n      opacity: ",
        ";\n    }\n\n    > svg,\n    > .MuiCircularProgress-root {\n      transition: opacity 200ms;\n    }\n\n    &::after {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      border: 2px solid transparent;\n      border-radius: inherit;\n\n      box-sizing: border-box;\n    }\n\n    &:hover {\n      background-color: ",
        ";\n\n      &::after {\n        border-color: ",
        ";\n      }\n    }\n\n    &:focus,\n    &:active {\n      background-color: ",
        ";\n\n      &::after {\n        border-color: ",
        ";\n      }\n    }\n\n    > span.spacer {\n      flex: 1;\n    }\n\n    > svg {\n      margin-left: 0.2rem;\n      color: ",
        ";\n      opacity: ",
        ";\n\n      &:first-child {\n        margin-left: 0rem;\n      }\n    }\n\n    .badge {\n      margin-right: 0;\n      margin-left: 0.5rem;\n      font-weight: normal;\n    }\n  "
    ]);
    OmnibarSearchButton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var OmnibarSearchButtonStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4b0097f-0"
})(OmnibarSearchButton_templateObject());
var OmnibarSearchButton_Styled = {
    Button: styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
        componentId: "sc-b4b0097f-1"
    })(OmnibarSearchButton_templateObject1(), Theme/* Color.primary */.Il.primary, Theme/* Color.white */.Il.white, function(param) {
        var loading = param.loading;
        return loading === 'true' ? 1 : 0;
    }, (0,polished_esm/* darken */._j)(0.1, Theme/* Color.primary */.Il.primary), Theme/* Color.secondary */.Il.secondary, (0,polished_esm/* darken */._j)(0.1, Theme/* Color.primary */.Il.primary), Theme/* Color.primary */.Il.primary, Theme/* Color.white */.Il.white, function(param) {
        var loading = param.loading;
        return loading === 'true' ? 0 : 1;
    })
};
var OmnibarSearchButton = function(param) {
    var icon = param.icon, _count = param.count, count = _count === void 0 ? 0 : _count, iconRight = param.iconRight, _className = param.className, className = _className === void 0 ? '' : _className, onClick = param.onClick, children = param.children;
    var isSearchLoading = (0,lib_state/* useScopedState */.S)(searchStore/* searchState */.uv, [
        'isSearchLoading'
    ]).isSearchLoading;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarSearchButtonStyle, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OmnibarSearchButton_Styled.Button, {
            loading: isSearchLoading ? 'true' : 'false',
            className: className,
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                    "aria-hidden": "true",
                    size: 20,
                    thickness: 4.5,
                    style: {
                        color: Theme/* Color.white */.Il.white
                    }
                }),
                icon || null,
                " ",
                children
            ]
        })
    }));
};

// EXTERNAL MODULE: ./components/Header.tsx
var Header = __webpack_require__(18969);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./components/select/SelectBase.tsx + 1 modules
var SelectBase = __webpack_require__(96637);
// EXTERNAL MODULE: ./common-react/selectOptionLogic.ts + 1 modules
var selectOptionLogic = __webpack_require__(97951);
;// CONCATENATED MODULE: ./components/select/CheckboxSelect.tsx









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function CheckboxSelect_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CheckboxSelect_templateObject() {
    var data = CheckboxSelect_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    CheckboxSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CheckboxSelect_templateObject1() {
    var data = CheckboxSelect_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n"
    ]);
    CheckboxSelect_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CheckboxSelect_templateObject2() {
    var data = CheckboxSelect_taggedTemplateLiteral([
        "\n  flex: 1;\n  padding: 0.5rem 0 0 0;\n  user-select: none;\n\n  > div {\n    display: flex;\n    flex-direction: column;\n    margin-left: 0.4rem;\n    padding-left: 1rem;\n    border-left: 2px solid ",
        ";\n  }\n\n  .MuiIconButton-label svg {\n    width: 18px;\n    height: 18px;\n  }\n"
    ]);
    CheckboxSelect_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-465dede6-0"
})(CheckboxSelect_templateObject());
var List = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-465dede6-1"
})(CheckboxSelect_templateObject1());
var CheckboxRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-465dede6-2"
})(CheckboxSelect_templateObject2(), Theme/* Color.background */.Il.background);
var ItemComponent = /*#__PURE__*/ (0,react.memo)(function(param) {
    var componentId = param.componentId, id1 = param.id, option1 = param.option, childDictionary = param.childDictionary, onSelect = param.onSelect, onOpen = param.onOpen;
    var name = option1.name, isSelected = option1.isSelected, selectedChildCount = option1.selectedChildCount, children = option1.children;
    var isParent = children.length > 0;
    var isIndeterminate = !isSelected && !!selectedChildCount;
    var directChildren = Object.values(childDictionary).filter(function(item) {
        return item.level === option1.level + 1;
    });
    var renderSuboption = function(option) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ItemComponent, {
            componentId: componentId,
            id: option.id,
            option: _objectSpread({}, option),
            childDictionary: option.children.reduce(function(dictionary, id) {
                return _objectSpread({}, dictionary, _defineProperty({}, id, childDictionary[id]));
            }, {}),
            onSelect: onSelect,
            onOpen: onOpen
        }, option.id);
    };
    if (isParent) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckboxRow, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        name: id1,
                        color: "primary",
                        indeterminate: isIndeterminate
                    }),
                    label: name,
                    checked: isSelected,
                    onChange: onSelect(id1)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: directChildren.map(renderSuboption)
                })
            ]
        }, id1));
    } else {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxRow, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    name: id1,
                    color: "primary"
                }),
                label: name,
                checked: isSelected,
                onChange: onSelect(id1)
            })
        }, id1));
    }
}, function(prev, next) {
    if (prev.componentId !== next.componentId) return false;
    if (prev.id !== next.id) return false;
    if (!(0,selectOptionLogic/* compareSelectItems */.qx)(prev.option, next.option)) {
        return false;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Is required because checkbox list renders children withing parent (not good)
        for(var _iterator = Object.keys(next.childDictionary)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var child = _step.value;
            if (!prev.childDictionary[child]) return false;
            if (!(0,selectOptionLogic/* compareSelectItems */.qx)(prev.childDictionary[child], next.childDictionary[child])) {
                return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
});
var CheckboxSelect = function(_param) {
    var _style = _param.style, style = _style === void 0 ? {} : _style, props = _objectWithoutProperties(_param, [
        "style"
    ]);
    /** Render a list item */ var renderListItem = function(option, itemDictionary, handleSelect, handleOpen) {
        var id2 = option.id, index = option.index;
        var componentId = props.id;
        var itemProps = {
            componentId: componentId,
            id: id2,
            option: option,
            childDictionary: option.children.reduce(function(dictionary, id) {
                return _objectSpread({}, dictionary, _defineProperty({}, id, itemDictionary[id]));
            }, {}),
            onSelect: handleSelect,
            onOpen: handleOpen
        };
        return(/*#__PURE__*/ (0,react.createElement)(ItemComponent, _objectSpread({}, itemProps, {
            key: "".concat(componentId, "-option-").concat(index)
        })));
    };
    /** Render all list items */ var renderListItems = function(items, itemDictionary, handleSelect, handleOpen) {
        var renderedItems = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (item.parents.length === 0) {
                    renderedItems.push(renderListItem(item, itemDictionary, handleSelect, handleOpen));
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return renderedItems;
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(SelectBase/* SelectBase */.Ky, _objectSpread({}, props, {
        containerComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {}),
        listComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
            style: style
        }),
        itemComponent: ItemComponent,
        isParentOpenable: false,
        renderListItems: renderListItems
    })));
};


// EXTERNAL MODULE: ./components/company/CompanyGrid.tsx
var CompanyGrid = __webpack_require__(66235);
// EXTERNAL MODULE: ./components/company/CompanyDictionary.tsx
var CompanyDictionary = __webpack_require__(81628);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Slider/Slider.js + 1 modules
var Slider = __webpack_require__(59122);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
;// CONCATENATED MODULE: ./components/omnibar/OmnibarSlider.tsx







function OmnibarSlider_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function OmnibarSlider_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = OmnibarSlider_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function OmnibarSlider_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function OmnibarSlider_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function OmnibarSlider_templateObject() {
    var data = OmnibarSlider_taggedTemplateLiteral([
        "\n  padding: 0 1rem;\n  box-sizing: border-box;\n"
    ]);
    OmnibarSlider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var OmnibarSlider_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2ae5b07-0"
})(OmnibarSlider_templateObject());
var ConstleSlider = (0,withStyles/* default */.Z)({
    thumb: {
    },
    valueLabel: {
        left: -34,
        top: 28,
        width: 80,
        textAlign: 'center',
        fontSize: '1rem',
        '& *': {
            background: 'transparent',
            color: '#000',
            transform: 'none',
            width: '100%'
        }
    }
})(Slider/* default */.Z);
var OmnibarSlider = function(param) {
    var title = param.title, path = param.path, _values = param.values, values = _values === void 0 ? [] : _values, valueToLabel = param.valueToLabel;
    var _ref = (0,lib_state/* useScopedState */.S)(advancedSearchStore/* advancedSearchState */.dK, [
        path
    ]), set = _ref.set, state = OmnibarSlider_objectWithoutProperties(_ref, [
        "set"
    ]);
    var value = state[path];
    var handleChange = function(event, newValue) {
        set(OmnibarSlider_defineProperty({}, path, newValue));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                small: true,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarSlider_Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConstleSlider, {
                    value: value,
                    onChange: handleChange,
                    getAriaValueText: valueToLabel,
                    valueLabelFormat: valueToLabel,
                    "aria-labelledby": "discrete-slider",
                    marks: true,
                    min: 0,
                    max: values.length - 1,
                    scale: function(x) {
                        return values[x];
                    },
                    valueLabelDisplay: "on"
                })
            })
        ]
    }));
};


// EXTERNAL MODULE: ./components/Badge.tsx
var Badge = __webpack_require__(44632);
// EXTERNAL MODULE: ./context/useSearch.ts
var useSearch = __webpack_require__(41351);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/mdi-react/CloseCircleOutlineIcon.js
var CloseCircleOutlineIcon = __webpack_require__(54564);
var CloseCircleOutlineIcon_default = /*#__PURE__*/__webpack_require__.n(CloseCircleOutlineIcon);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
;// CONCATENATED MODULE: ./components/omnibar/ClearFilterButton.tsx







function ClearFilterButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ClearFilterButton_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ClearFilterButton_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ClearFilterButton_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ClearFilterButton_templateObject() {
    var data = ClearFilterButton_taggedTemplateLiteral([
        "\n  .MuiIconButton-label {\n    width: 24px;\n  }\n\n  svg {\n    width: 24px;\n    height: 24px;\n  }\n"
    ]);
    ClearFilterButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-fe2e0530-0"
})(ClearFilterButton_templateObject());
var ClearFilterButton = function(props) {
    var intl = (0,useIntl/* default */.Z)();
    var tooltipMessage = intl.formatMessage({
        id: 'search.advanced.clearButton.tooltip',
        defaultMessage: 'Poista valinnat'
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
        title: tooltipMessage,
        placement: "right",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconButton, ClearFilterButton_objectSpread({
            "aria-label": tooltipMessage.toLowerCase(),
            size: "small",
            style: {
                width: 22,
                height: 22,
                padding: 0
            }
        }, props, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((CloseCircleOutlineIcon_default()), {})
        }))
    }));
};

;// CONCATENATED MODULE: ./components/omnibar/OmnibarAdvanced.tsx

















function OmnibarAdvanced_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function OmnibarAdvanced_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            OmnibarAdvanced_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function OmnibarAdvanced_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function OmnibarAdvanced_templateObject() {
    var data = OmnibarAdvanced_taggedTemplateLiteral([
        "\n  > div .MuiFormControlLabel-root {\n  }\n"
    ]);
    OmnibarAdvanced_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OmnibarAdvanced_templateObject1() {
    var data = OmnibarAdvanced_taggedTemplateLiteral([
        "\n  .select-list {\n    flex-direction: column;\n    align-items: stretch;\n    max-height: 320px;\n  }\n\n  ",
        " {\n    flex: none;\n  }\n"
    ]);
    OmnibarAdvanced_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OmnibarAdvanced_templateObject2() {
    var data = OmnibarAdvanced_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row-reverse;\n  margin-bottom: 1rem;\n  padding: ",
        ";\n"
    ]);
    OmnibarAdvanced_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var CheckboxColumn = (0,styled_components_browser_esm/* default */.ZP)(CompanyGrid/* Column */.sg).withConfig({
    componentId: "sc-8debeb94-0"
})(OmnibarAdvanced_templateObject());
var VerticalCheckboxSelect = (0,styled_components_browser_esm/* default */.ZP)(CheckboxSelect).withConfig({
    componentId: "sc-8debeb94-1"
})(OmnibarAdvanced_templateObject1(), CheckboxRow);
var Actions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8debeb94-2"
})(OmnibarAdvanced_templateObject2(), function(param) {
    var page = param.page;
    return page ? '1rem' : '0 1rem 0 0';
});
/** Get count of all advanced options */ var getAdvancedOptionCount = function() {
    var ref = advancedSearchStore/* advancedSearchState.getState */.dK.getState(), contractingForms = ref.contractingForms, languages = ref.languages, machineryTypes = ref.machineryTypes, projectTypes = ref.projectTypes, taitoCompetences = ref.taitoCompetences, targetGroups = ref.targetGroups, tol2008 = ref.tol2008;
    /** Enforce that all advanced search options are handled here */ var advancedOptions = {
        contractingForms: contractingForms,
        languages: languages,
        machineryTypes: machineryTypes,
        projectTypes: projectTypes,
        taitoCompetences: taitoCompetences,
        targetGroups: targetGroups,
        tol2008: tol2008
    };
    return Object.values(advancedOptions).reduce(function(count, state) {
        return count + state.count;
    }, 0);
};
/** Helper to quickly add search context items as checkbox selects */ var OmnibarAdvancedSelect = function(param) {
    var title = param.title, path = param.path, _style = param.style, style = _style === void 0 ? {} : _style, _vertical = param.vertical, vertical = _vertical === void 0 ? false : _vertical, _chip = param.chip, chip = _chip === void 0 ? false : _chip;
    var items = (0,lib_state/* useScopedState */.S)(staticStore/* staticState */.G, [
        path
    ])[path];
    var ref = (0,advancedSearchStore/* useSearchFilter */.dl)(path), state = ref.state, set = ref.set;
    var selected = state.selected, count = state.count;
    var handleFilterClear = function() {
        set({
            selected: [],
            count: 0
        });
    };
    var selectProps = {
        id: "advanced-".concat(path, "-select"),
        items: items,
        selected: selected,
        onSelect: set,
        style: style
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header/* Header */.h, {
                small: true,
                children: [
                    title,
                    count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                children: count
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearFilterButton, {
                                onClick: handleFilterClear
                            })
                        ]
                    })
                ]
            }),
            !chip && (vertical ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalCheckboxSelect, OmnibarAdvanced_objectSpread({}, selectProps)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxSelect, OmnibarAdvanced_objectSpread({}, selectProps))),
            !!chip && /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarSelect, {
                id: selectProps.id,
                title: title,
                path: path,
                chip: true
            })
        ]
    }));
};
/** Number of employees slider */ var getValueTextForNumberOfEmployees = function(value) {
    return "".concat(value).concat(value === advancedSearchStore/* numberOfEmployeeMarks */.N0[advancedSearchStore/* numberOfEmployeeMarks.length */.N0.length - 1] ? '+' : '', " hl\xf6.");
};
var getValueTextForDateEstablished = function(value) {
    return "v. ".concat(value).concat(value === numberOfEmployeeMarks[numberOfEmployeeMarks.length - 1] ? '+' : '');
};
/** Sales per year slider */ var numberWithSpaces = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
var getValueTextForTurnover = function(value) {
    if (value < 1000) return "".concat(numberWithSpaces(value * 1000), " ").concat(value === advancedSearchStore/* turnoverMarks */.BL[advancedSearchStore/* turnoverMarks.length */.BL.length - 1] ? '+' : '', " €");
    return "".concat(value / 1000, "milj.").concat(value === advancedSearchStore/* turnoverMarks */.BL[advancedSearchStore/* turnoverMarks.length */.BL.length - 1] ? '+' : '', " €");
};
var OmnibarAdvanced = function(param) {
    var _page = param.page, page = _page === void 0 ? false : _page;
    var dictiorary = (0,CompanyDictionary/* useCompanyDictionary */.F)();
    var set = (0,lib_state/* useScopedState */.S)(advancedSearchStore/* advancedSearchState */.dK, []).set;
    var doSearch = (0,useSearch/* useSearch */.R)().doSearch;
    var handleSearchClear = function() {
        set(OmnibarAdvanced_objectSpread({}, advancedSearchStore/* advancedSearchStateDefaults */.kP));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Grid */.rj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Column */.sg, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarAdvancedSelect, {
                        title: dictiorary.projectTypes,
                        path: "projectTypes"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Grid */.rj, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxColumn, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarSlider, {
                            title: dictiorary.numberOfEmployees,
                            path: "numberOfEmployees",
                            values: advancedSearchStore/* numberOfEmployeeMarks */.N0,
                            valueToLabel: getValueTextForNumberOfEmployees
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxColumn, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarSlider, {
                            title: dictiorary.turnover,
                            path: "turnover",
                            values: advancedSearchStore/* turnoverMarks */.BL,
                            valueToLabel: getValueTextForTurnover
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Grid */.rj, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxColumn, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarAdvancedSelect, {
                            title: dictiorary.customerTargetGroups,
                            path: "targetGroups",
                            vertical: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxColumn, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarAdvancedSelect, {
                            title: dictiorary.contractingForms,
                            path: "contractingForms",
                            vertical: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxColumn, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarAdvancedSelect, {
                            title: dictiorary.languages,
                            path: "languages",
                            vertical: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Grid */.rj, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Column */.sg, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarAdvancedSelect, {
                            title: dictiorary.taitoCompetences,
                            path: "taitoCompetences",
                            style: {
                                maxHeight: 700
                            },
                            vertical: true,
                            chip: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Column */.sg, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarAdvancedSelect, {
                            title: dictiorary.tol,
                            path: "tol2008",
                            style: {
                                maxHeight: 700
                            },
                            vertical: true,
                            chip: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Actions, {
                page: page,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((MagnifyIcon_default()), {}),
                        onClick: function() {
                            return doSearch();
                        },
                        children: "Hae"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        variant: "text",
                        onClick: handleSearchClear,
                        children: "Tyhjenn\xe4 haku"
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/OutlinedInput/OutlinedInput.js + 1 modules
var OutlinedInput = __webpack_require__(74061);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./hooks/useBreakPoint.ts
var useBreakPoint = __webpack_require__(41894);
;// CONCATENATED MODULE: ./components/omnibar/OmnibarSearchInput.tsx


















function OmnibarSearchInput_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function OmnibarSearchInput_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            OmnibarSearchInput_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function OmnibarSearchInput_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _throw(e) {
    throw e;
}
function OmnibarSearchInput_templateObject() {
    var data = OmnibarSearchInput_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-right: 4px;\n  padding: 2px 4px 2px 7px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  color: white;\n  opacity: 0.4;\n  user-select: none;\n  pointer-events: none;\n\n  @media (max-width: 640px) {\n    display: none;\n  }\n\n  svg {\n    margin-left: 3px;\n    width: 20px;\n    height: 20px;\n  }\n"
    ]);
    OmnibarSearchInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OmnibarSearchInput_templateObject1() {
    var data = OmnibarSearchInput_taggedTemplateLiteral([
        "\n    display: block;\n\n    > input {\n      padding-left: 3.9rem !important;\n    }\n  "
    ]);
    OmnibarSearchInput_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OmnibarSearchInput_templateObject2() {
    var data = OmnibarSearchInput_taggedTemplateLiteral([
        "\n  &:not(.Mui-focused) {\n    ",
        " {\n      display: none;\n    }\n  }\n\n  > input {\n    padding-left: 0.45rem !important;\n  }\n\n  ",
        "\n"
    ]);
    OmnibarSearchInput_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = OmnibarSearchInput_taggedTemplateLiteral([
        "\n    display: block;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = OmnibarSearchInput_taggedTemplateLiteral([
        "\n  position: absolute;\n  display: none;\n  user-select: none;\n  pointer-events: none;\n\n  h2 {\n    margin: 0 0 0 0.4rem;\n    font-size: 1.06rem;\n    font-weight: bold;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var Keybinding = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-96a79b29-0"
})(OmnibarSearchInput_templateObject(), Theme/* Color.disabled */.Il.disabled, Theme/* borderRadius */.E0);
var OutlinedSearchInput = (0,styled_components_browser_esm/* default */.ZP)(OutlinedInput/* default */.Z).withConfig({
    componentId: "sc-96a79b29-1"
})(OmnibarSearchInput_templateObject2(), Keybinding, Theme/* mediaQuery.small */.cy.small((0,styled_components_browser_esm/* css */.iv)(OmnibarSearchInput_templateObject1())));
var SearchInputLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-96a79b29-2"
})(_templateObject4(), Theme/* mediaQuery.small */.cy.small((0,styled_components_browser_esm/* css */.iv)(_templateObject3())));
var searchUpdateTimeout = null;
var OmnibarSearchInput = function(param) {
    var param = param !== null ? param : _throw(new TypeError("Cannot destructure undefined"));
    var intl = (0,useIntl/* default */.Z)();
    var pathname = (0,next_router.useRouter)().pathname;
    var doSearch = (0,useSearch/* useSearch */.R)().doSearch;
    var doClearSearch = (0,searchStore/* useClearSearch */.FJ)().doClearSearch;
    var isAdvancedSearchDirty = (0,advancedSearchStore/* useSearchDirty */.Bl)();
    var isMedium = (0,useBreakPoint/* useBreakPoint */.P)('medium');
    var searchInput = (0,lib_state/* useFieldState */.t)(searchStore/* searchState */.uv, 'searchText');
    var isSearchDirty = searchInput.value || isAdvancedSearchDirty;
    var placeholderMessageLong = intl.formatMessage({
        id: 'search.input.placeholder.long',
        defaultMessage: 'Toimiala, yrityksen nimi, toimialue, kohdetyyppi…'
    });
    var placeholderMessageShort = intl.formatMessage({
        id: 'search.input.placeholder.short',
        defaultMessage: 'Yrityksen nimi, toimialue…'
    });
    var placeholderMessage = isMedium ? placeholderMessageShort : placeholderMessageLong;
    var clearTooltipMessage = intl.formatMessage({
        id: 'search.input.clearButton.tooltip',
        defaultMessage: 'Nollaa kaikki rajaukset'
    });
    var handleSearchKeyUp = function(event) {
        if (event.key === 'Enter') {
            /** Unfocus so the quick search list does not cover the actual search results */ setTimeout(function() {
                document.activeElement.blur();
            }, 0);
            /*
      if (selected !== null) {
        handleQuickSearchResult();
        return;
      }
      */ doSearch();
            return;
        }
        // @ts-ignore
        var isSelectorRight = event.target.selectionStart === event.target.value.length;
        if (event.key === 'ArrowDown' && isSelectorRight) {
            /*
      event.preventDefault();

      if (selected === null) {
        setSelected(0);
      } else {
        setSelected(Math.min(selected + 1, quickSearchData.length - 1));
      }
      */ return;
        }
        if (event.key === 'ArrowUp' /* && selected !== null*/ ) {
            /*
      event.preventDefault();

      if (selected === 0) {
        setSelected(null);
      } else {
        setSelected(selected - 1);
      }
      */ return;
        }
    };
    var handleSearchClick = function() {
        return doSearch();
    };
    var handleSearchFocus = function() {
    // setHasFocus(true);
    // setSelected(null);
    };
    var handleSearchBlur = function() {
    // setTimeout(() => setHasFocus(false), 100);
    };
    /*
  const handleQuickSearchResult = () => {
    if (selected !== null) {
      const company = quickSearchData[selected];
      const hash = encodeCompanyIDHash(company.companyID);
      const name = slugify(company.name);
      router.push('/company/[hash]/[slug]', `/company/${hash}/${name}`);
    }
    return;
  };

  const handleQuickSearchListClick = () => {
    handleQuickSearchResult();
    return;
  };
  */ var handleSearchClear = function() {
        doClearSearch();
        if (pathname !== '/') {
            doSearch('');
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlinedSearchInput, OmnibarSearchInput_objectSpread({
            fullWidth: true,
            placeholder: placeholderMessage
        }, searchInput, {
            onKeyUp: handleSearchKeyUp,
            onFocus: handleSearchFocus,
            onBlur: handleSearchBlur,
            // FIXME: Enable when quick search has been implemented
            // role="combobox"
            // aria-haspopup="listbox"
            // aria-owns="quick-search-list"
            // aria-expanded={false /*isListOpen*/}
            role: "search",
            inputProps: {
                id: 'search-input'
            },
            style: {
                paddingRight: 4
            },
            endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputAdornment/* default */.Z, {
                position: "end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Keybinding, {
                        children: [
                            "ENTER ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((MagnifyIcon_default()), {})
                        ]
                    }),
                    isSearchDirty && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                        title: clearTooltipMessage,
                        placement: "left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            "aria-label": clearTooltipMessage.toLowerCase(),
                            onClick: handleSearchClear,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((CloseCircleOutlineIcon_default()), {})
                        })
                    })
                ]
            }),
            startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInputLabel, {
                "aria-hidden": true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "search.input.label",
                        defaultMessage: "Haku"
                    })
                })
            })
        }))
    }));
};

;// CONCATENATED MODULE: ./components/omnibar/Omnibar.tsx




















function Omnibar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Omnibar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Omnibar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Omnibar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Omnibar_templateObject() {
    var data = Omnibar_taggedTemplateLiteral([
        "\n        margin-bottom: 0;\n        max-width: 100%;\n      "
    ]);
    Omnibar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Omnibar_templateObject1() {
    var data = Omnibar_taggedTemplateLiteral([
        "\n        border-radius: ",
        "px ",
        "px ",
        "px 0;\n      "
    ]);
    Omnibar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Omnibar_templateObject2() {
    var data = Omnibar_taggedTemplateLiteral([
        "\n        display: none;\n      "
    ]);
    Omnibar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Omnibar_templateObject3() {
    var data = Omnibar_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    height: auto;\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    Omnibar_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Omnibar_templateObject4() {
    var data = Omnibar_taggedTemplateLiteral([
        "\n      flex-direction: column;\n      height: auto;\n\n      > hr:first-of-type {\n        display: none;\n      }\n\n      .search-button span {\n        display: inline;\n      }\n\n      ",
        " {\n        width: 100%;\n      }\n\n      > .MuiInputBase-root {\n        flex: none !important;\n        width: 100%;\n        height: 66px;\n        border-radius: 0px;\n\n        input {\n          flex: 1;\n          width: 100%;\n        }\n\n        fieldset {\n          border-color: transparent;\n        }\n      }\n\n      > button {\n        width: 100%;\n        margin-top: -2px !important;\n        margin-left: 0;\n        height: 66px;\n        border-radius: 0 !important;\n        border-color: transparent !important;\n        border-top-color: ",
        " !important;\n\n        &:last-child {\n          border-radius: 0 0 ",
        "px ",
        "px !important;\n        }\n      }\n\n      > hr {\n        width: 100%;\n        height: 0;\n\n        &::after {\n          top: -2px;\n          left: 0;\n          height: 2px;\n          width: 100%;\n        }\n      }\n    "
    ]);
    Omnibar_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = Omnibar_taggedTemplateLiteral([
        "\n        > div:first-of-type {\n          border-radius: ",
        "px 0 0 0;\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = Omnibar_taggedTemplateLiteral([
        "\n        > div {\n          border-radius: 0 !important;\n        }\n\n        > div > div {\n          border-radius: 0 !important;\n        }\n\n        > button {\n          border-radius: 0 !important;\n        }\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = Omnibar_taggedTemplateLiteral([
        "\n    display: flex;\n    position: relative;\n    height: 66px;\n    ",
        "\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n\n    .search-button span {\n      display: none;\n    }\n\n    > .MuiOutlinedInput-root {\n      .MuiInputAdornment-root {\n        margin-right: 0.4rem;\n      }\n\n      input {\n        padding-left: 1.6rem;\n        font-size: 1.06rem;\n      }\n    }\n\n    fieldset {\n      border-width: 2px;\n      border-color: transparent;\n    }\n\n    > button {\n      margin-left: -2px;\n\n      &:last-of-type {\n        border-radius: 0 ",
        "px ",
        "px 0;\n        border-right-color: ",
        ";\n      }\n    }\n\n    > div:first-of-type {\n      flex: 1;\n      border-radius: ",
        "px 0 0 ",
        "px;\n\n      > div:not(.badge) {\n        border-radius: ",
        "px 0 0 ",
        "px;\n      }\n    }\n\n    .MuiInputBase-root,\n    .MuiFormControl-root,\n    button {\n      &:hover,\n      &:active,\n      &:focus {\n        z-index: 3;\n      }\n    }\n\n    .Mui-focused,\n    button:focus,\n    button:active {\n      z-index: 3;\n    }\n\n    > hr {\n      position: relative;\n      align-self: stretch;\n      margin: 0;\n      width: 0;\n      height: 100%;\n      border: none;\n      overflow: visible;\n\n      &:first-of-type {\n        &::after {\n          display: ",
        ";\n          left: 0;\n        }\n      }\n\n      &::after {\n        position: absolute;\n        display: block;\n        content: '';\n        top: 0;\n        left: -2px;\n        width: 2px;\n        height: 100%;\n        background-color: ",
        ";\n      }\n    }\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = Omnibar_taggedTemplateLiteral([
        "\n    display: ",
        ";\n    position: absolute;\n    left: 0;\n    top: calc(100% - 2px);\n    ",
        "\n    width: 600px;\n    border-radius: 0 0 ",
        "px ",
        "px;\n    z-index: 2;\n\n    box-shadow: 0 6px 6px rgba(149, 157, 165, 0.15);\n\n    > div:first-of-type a {\n      border-radius: 0;\n    }\n\n    @media (max-width: 640px) {\n      top: calc(100% - (66px * 2));\n      width: 100%;\n    }\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = Omnibar_taggedTemplateLiteral([
        "\n    width: 100%;\n    background-color: ",
        ";\n\n    &::before {\n      position: absolute;\n      content: '';\n      display: block;\n      margin-top: -2px;\n      left: 0;\n      width: 100%;\n      height: 2px;\n      background-color: ",
        ";\n    }\n\n    > div {\n      ",
        "\n      padding-left: 0 !important;\n      padding-right: 0 !important;\n    }\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
var Omnibar_Styled = {
    Omnibar: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-3fc126be-0"
    })(Omnibar_templateObject3(), Theme/* cardStyles */.F, function(props) {
        return props.fullPage && (0,styled_components_browser_esm/* css */.iv)(Omnibar_templateObject());
    }, function(props) {
        return props.isListOpen && (0,styled_components_browser_esm/* css */.iv)(Omnibar_templateObject1(), Theme/* borderRadius */.E0, Theme/* borderRadius */.E0, Theme/* borderRadius */.E0);
    }, function(param) {
        var hasMobileBar = param.hasMobileBar;
        return hasMobileBar && Theme/* mediaQuery.small */.cy.small((0,styled_components_browser_esm/* css */.iv)(Omnibar_templateObject2()));
    }),
    Container: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-3fc126be-1"
    })(_templateObject7(), Theme/* layoutStyles */.pG, Theme/* borderRadius */.E0, Theme/* borderRadius */.E0, function(props) {
        return props.fullPage ? Theme/* Color.background */.Il.background : 'transparent';
    }, Theme/* borderRadius */.E0, Theme/* borderRadius */.E0, Theme/* borderRadius */.E0, Theme/* borderRadius */.E0, function(props) {
        return props.fullPage ? 'block' : 'none';
    }, Theme/* Color.background */.Il.background, Theme/* mediaQuery.small */.cy.small((0,styled_components_browser_esm/* css */.iv)(Omnibar_templateObject4(), OmnibarSearchButtonStyle, Theme/* Color.background */.Il.background, Theme/* borderRadius */.E0, Theme/* borderRadius */.E0)), function(props) {
        return props.isListOpen && (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), Theme/* borderRadius */.E0);
    }, function(props) {
        return props.fullPage && (0,styled_components_browser_esm/* css */.iv)(_templateObject6());
    }),
    List: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-3fc126be-2"
    })(_templateObject8(), function(props) {
        return props.isListOpen ? 'block' : 'none';
    }, Theme/* cardStyles */.F, Theme/* borderRadius */.E0, Theme/* borderRadius */.E0),
    Advanced: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-3fc126be-3"
    })(_templateObject9(), Theme/* Color.white */.Il.white, Theme/* Color.background */.Il.background, Theme/* layoutStyles */.pG)
};
var Omnibar = function(param) {
    var _fullPage = param.fullPage, fullPage = _fullPage === void 0 ? false : _fullPage, _hasMobileBar = param.hasMobileBar, hasMobileBar = _hasMobileBar === void 0 ? false : _hasMobileBar;
    var router = (0,next_router.useRouter)();
    var hasPremium = (0,useUser/* useUser */.a)().hasPremium;
    var ref = (0,useSearch/* useSearch */.R)(), doSearch = ref.doSearch, set = ref.set, isAdvancedSearchOpen = ref.isAdvancedSearchOpen;
    // Close the advanced search when navigating between pages
    (0,react.useEffect)(function() {
        set({
            isAdvancedSearchOpen: false
        });
    }, [
        router.pathname
    ]);
    var isListOpen = false; // searchText.length > 0 && quickSearchData.length && hasFocus;
    var containerProps = {
        fullPage: fullPage,
        isListOpen: isListOpen,
        hasMobileBar: hasMobileBar
    };
    var handleSearchClick = function() {
        return doSearch();
    };
    var handleFilterPopupClose = function(changed) {
        if (!changed) return;
        if (router.pathname === '/') return;
        // Add a small delay for smooth close animation
        setTimeout(function() {
            handleSearchClick();
        }, 10);
    };
    var handleMoreClick = function() {
        if (!hasPremium && (0,paywallStore/* openPaywall */.Oo)('advanced')) return;
        set({
            isAdvancedSearchOpen: !isAdvancedSearchOpen
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Omnibar_Styled.Omnibar, Omnibar_objectSpread({
        className: "omnibar"
    }, containerProps, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Omnibar_Styled.Container, Omnibar_objectSpread({}, containerProps, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarSearchInput, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarSelect, {
                        id: "toimialue",
                        title: "Toimialue",
                        path: "operationalAreas",
                        onClose: handleFilterPopupClose
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarSelect, {
                        id: "toimialaluokat",
                        title: "Toimialaluokat",
                        path: "talo80",
                        onClose: handleFilterPopupClose
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarButton/* OmnibarButton */.j, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((TuneIcon_default()), {}),
                        iconRight: isAdvancedSearchOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)((MenuUpIcon_default()), {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)((MenuDownIcon_default()), {}),
                        count: getAdvancedOptionCount(),
                        onClick: handleMoreClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "search.advanced.showMoreButton",
                            defaultMessage: "Lis\xe4\xe4"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarSearchButton, {
                        className: "search-button",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((MagnifyIcon_default()), {}),
                        iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)((MenuRightIcon_default()), {
                            style: {
                                marginLeft: -4
                            }
                        }),
                        onClick: handleSearchClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "search.searchButton",
                                defaultMessage: "Hae"
                            })
                        })
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                in: isAdvancedSearchOpen,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Omnibar_Styled.Advanced, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarAdvanced, {})
                })
            })
        ]
    })));
};


/***/ }),

/***/ 77249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ OmnibarButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83852);
/* harmony import */ var mdi_react_MenuDownIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88251);
/* harmony import */ var mdi_react_MenuDownIcon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(mdi_react_MenuDownIcon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74815);
/* harmony import */ var _Badge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44632);






function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n    position: relative;\n    padding: 0 1rem 0 1.4rem;\n    font-size: 1.06rem;\n    font-weight: ",
        ";\n    font-family: 'Roboto', sans-serif;\n    background: none;\n    background-color: ",
        ";\n    border-radius: 0;\n    border: none;\n    outline: none;\n    color: ",
        ";\n\n    cursor: pointer;\n\n    &::after {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      border: 2px solid transparent;\n      border-radius: inherit;\n\n      box-sizing: border-box;\n    }\n\n    &:hover {\n      background-color: ",
        ";\n\n      &::after {\n        border-color: ",
        ";\n      }\n    }\n\n    &:focus,\n    &:active {\n      background-color: ",
        ";\n\n      &::after {\n        border-color: ",
        ";\n      }\n    }\n\n    > span.spacer {\n      flex: 1;\n    }\n\n    > svg {\n      margin-left: 0.2rem;\n      color: ",
        ";\n\n      &:first-child {\n        margin-left: 0rem;\n        margin-right: 0.3rem;\n      }\n    }\n\n    .badge {\n      margin-right: 0;\n      margin-left: 0.5rem;\n      font-weight: normal;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Styled = {
    Button: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
        componentId: "sc-3857a0a2-0"
    })(_templateObject(), function(param) {
        var primary = param.primary;
        return primary ? 500 : 'bold';
    }, function(param) {
        var primary = param.primary;
        return primary ? _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.primary */ .Il.primary : 'transparent';
    }, function(param) {
        var primary = param.primary;
        return primary ? _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.white */ .Il.white : _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.secondary */ .Il.secondary;
    }, function(param) {
        var primary = param.primary;
        return primary ? (0,polished__WEBPACK_IMPORTED_MODULE_5__/* .darken */ ._j)(0.1, _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.primary */ .Il.primary) : _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.hover */ .Il.hover;
    }, _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.secondary */ .Il.secondary, function(param) {
        var primary = param.primary;
        return primary ? (0,polished__WEBPACK_IMPORTED_MODULE_5__/* .darken */ ._j)(0.1, _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.primary */ .Il.primary) : _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.select */ .Il.select;
    }, _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.primary */ .Il.primary, function(param) {
        var primary = param.primary;
        return primary ? _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.white */ .Il.white : _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.primary */ .Il.primary;
    })
};
var OmnibarButton = function(param) {
    var icon = param.icon, _count = param.count, count = _count === void 0 ? 0 : _count, iconRight = param.iconRight, _primary = param.primary, primary = _primary === void 0 ? false : _primary, _className = param.className, className = _className === void 0 ? '' : _className, onClick = param.onClick, children = param.children;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Styled.Button, {
        className: className,
        primary: primary,
        onClick: onClick,
        children: [
            icon || null,
            " ",
            children,
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "spacer"
            }),
            " ",
            count > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Badge__WEBPACK_IMPORTED_MODULE_3__/* .Badge */ .C, {
                children: count
            }),
            ' ',
            iconRight !== undefined ? iconRight : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_MenuDownIcon__WEBPACK_IMPORTED_MODULE_1___default()), {})
        ]
    });
};


/***/ }),

/***/ 41351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useSearch; }
/* harmony export */ });
/* harmony import */ var _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var _lib_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54442);
/* harmony import */ var _searchStore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90672);
/* harmony import */ var _searchCache__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30123);





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
/** Hook to make searching from any page easy */ var useSearch = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref1 = (0,_lib_state__WEBPACK_IMPORTED_MODULE_2__/* .useScopedState */ .S)(_searchStore__WEBPACK_IMPORTED_MODULE_3__/* .searchState */ .uv, [
        'isAdvancedSearchOpen'
    ]), set = ref1.set, isAdvancedSearchOpen = ref1.isAdvancedSearchOpen;
    /**
   * Do a search
   * - Handles cache
   * - Handles URL state
   */ var doSearch = function() {
        var _ref = _asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var searchText, route, actualSearchText, _args = arguments;
            return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        searchText = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null;
                        route = router.route;
                        actualSearchText = searchText !== null && searchText !== void 0 ? searchText : _searchStore__WEBPACK_IMPORTED_MODULE_3__/* .searchState.getState */ .uv.getState().searchText;
                        // Close the "advanced search" menu
                        set({
                            isAdvancedSearchOpen: false
                        });
                        if (!(route === '/search')) {
                            _ctx.next = 10;
                            break;
                        }
                        // We are at the search page, do a search
                        router.push({
                            pathname: '/search',
                            query: {
                                q: actualSearchText
                            }
                        }, null, {
                            scroll: false
                        });
                        _ctx.next = 8;
                        return _searchStore__WEBPACK_IMPORTED_MODULE_3__/* .searchState.getState */ .uv.getState().doSearch(actualSearchText);
                    case 8:
                        _ctx.next = 11;
                        break;
                    case 10:
                        {
                            // Switch to the search page
                            set({
                                isSearchLoading: true,
                                state: _searchStore__WEBPACK_IMPORTED_MODULE_3__/* .SearchProcessState.FRESH */ .wV.FRESH,
                                searchItems: [],
                                searchPage: 0
                            });
                            router.push({
                                pathname: '/search',
                                query: {
                                    q: actualSearchText
                                }
                            });
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function doSearch() {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Load more results for the current search
   * - Handles URL state
   */ var doLoadMore = function() {
        var _ref = _asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, currentSearchQuery, searchPage, page, text;
            return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = _searchStore__WEBPACK_IMPORTED_MODULE_3__/* .searchState.getState */ .uv.getState(), currentSearchQuery = ref.currentSearchQuery, searchPage = ref.searchPage;
                        page = searchPage + 1;
                        text = currentSearchQuery.fullTextSearch || '';
                        // Switch to the search page, or update the browsing history
                        router.replace({
                            pathname: '/search',
                            query: {
                                q: text,
                                p: page
                            }
                        }, null, {
                            scroll: false
                        });
                        _ctx.next = 6;
                        return _searchStore__WEBPACK_IMPORTED_MODULE_3__/* .searchState.getState */ .uv.getState().doLoadMore(page);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function doLoadMore() {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Figure out what should be done when the search page is loaded / updated
   * - Restores search text
   * - Restores search page
   * - Restores scroll position
   * - Restores search results
   */ var doInitSearch = function() {
        var _ref = _asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var searchText, searchPage, ref, currentSearchText, state, cacheEntry;
            return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        searchText = param.searchText, searchPage = param.searchPage;
                        ref = _searchStore__WEBPACK_IMPORTED_MODULE_3__/* .searchState.getState */ .uv.getState(), currentSearchText = ref.searchText, state = ref.state;
                        if (!(currentSearchText === searchText && state !== _searchStore__WEBPACK_IMPORTED_MODULE_3__/* .SearchProcessState.FRESH */ .wV.FRESH)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        cacheEntry = (0,_searchCache__WEBPACK_IMPORTED_MODULE_4__/* .checkSearchCache */ ._3)({
                            text: searchText,
                            page: searchPage
                        });
                        if (!cacheEntry) {
                            _ctx.next = 9;
                            break;
                        }
                        {
                            // Cache entry found, we can restore
                            (0,_searchCache__WEBPACK_IMPORTED_MODULE_4__/* .restoreSearchStateFromCache */ .mA)(cacheEntry);
                        }
                        _ctx.next = 12;
                        break;
                    case 9:
                        // No cache entry found, remove page param and do a regular search
                        router.replace({
                            pathname: '/search',
                            query: {
                                q: searchText
                            }
                        }, null, {
                            scroll: true
                        });
                        _ctx.next = 12;
                        return doSearch(searchText);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function doInitSearch(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        doSearch: doSearch,
        doLoadMore: doLoadMore,
        doInitSearch: doInitSearch,
        set: set,
        isAdvancedSearchOpen: isAdvancedSearchOpen
    };
};


/***/ })

}]);